
































































































































































































import Vue from 'vue';
import {
  Exhibition,
  exhibition as exhibitionM,
  calender,
} from 'mostra';

export type DataType = {
  isLoading: boolean;
  owner: string | null;
  exhibition: Exhibition | null;
  boothV2Type: number;
};

export default Vue.extend({
  name: 'admin-admin-exhibition-modify',
  data(): DataType {
    return {
      isLoading: true,
      exhibition: null,
      owner: null,
      boothV2Type: 2,
    };
  },
  methods: {
    async onClickCheck() {
      if (this.$refs && this.$refs.observer) {
        await (this.$refs.observer as any).validate();
      }
    },
    async onClickSave() {
      this.$loading(true);
      try {
        const uid = this.$auth.uid;
        console.log(uid);
        console.log(this.exhibition);
        if (this.exhibition) {
          const n = await exhibitionM.save(uid, this.exhibition, process.env.VUE_APP_SSR_URL);
          if (n && n.id) {
            this.$router.push({
              name: 'admin-admin-exhibition-modify',
              params: {
                id: n.id,
              },
            });
          }
        }
        this.$success('保存しました。');
      } catch (error: any) {
        console.log(error);
        this.$error('保存に失敗しました', error);
      } finally {
        this.$loading(false);
      }
    },
    formatDate(dt: any) {
      return calender.formatDate(dt);
    },
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    async fetchData() {
      this.$loading(true);
      this.isLoading = true;
      try {
        const id = this.$route.params.id;
        if (id === 'new') {
          this.owner = this.$route.query.owner as string;
          if (!this.owner) {
            throw Error('owner is null');
          }
          this.exhibition = exhibitionM.createNew(this.owner);
          if (!this.exhibition) throw new Error('exhibition is null');
          this.exhibition.data.boothType = this.boothV2Type;
        } else {
          const r = await exhibitionM.load(id);
          if (!r) throw Error('exhibition is null');
          this.owner = r.data.owner || this.$auth.cid;
          // バグだけどとしてあえて入れない
          r.data.owner = r.data.owner || '';
          this.exhibition = r;
        }
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.$loading(false);
        this.isLoading = false;
      }
    },
    addNewLocation(): void {
      const newLocation = exhibitionM.createNewLocation();
      if (this.exhibition) {
        this.exhibition.data.locations.push(newLocation);
      } else {
        throw new Error('exhibition is null');
      }
    },
  },
  async beforeRouteUpdate(to, from, next) {
    next();
    await this.fetchData();
  },
  async mounted() {
    await this.fetchData();
  },
});
